export default "__VITE_ASSET__4a9382c5__"